import { render, staticRenderFns } from "./MPopupMBody.vue?vue&type=template&id=578252dd&"
import script from "./MPopupMBody.vue?vue&type=script&lang=ts&"
export * from "./MPopupMBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports